export class Vector2
{
    public x : number = 0;
    public y : number = 0;

    constructor(x : number = 0, y : number = 0)
    {
        this.x = x;
        this.y = y;
    }

    // ベクトルを時計回りに回転
    public rotate(radian : number, cx : number, cy : number) : Vector2
    {
        var rx = (this.x - cx) * Math.cos(radian) - (this.y - cy) * Math.sin(radian) + cx;
        var ry = (this.x - cx) * Math.sin(radian) + (this.y - cy) * Math.cos(radian) + cy;
        return new Vector2(rx, ry);
    }

    // ベクトルを時計回りに回転
    public rotateDegrees(degrees : number, cx : number, cy : number) : Vector2
    {
        var radian = degrees * Math.PI / 180;
        return this.rotate(radian, cx, cy);
    }
     
    // ベクトルを指定角度時計回りに回転した座標系に分解する
    public getResolution(radian : number) : Vector2
    {
        // ベクトルの角度
        var phi = Math.atan2(this.y, this.x);
        // 新しいベクトルの角度
        var r = phi - radian;
        // ベクトルの長さ
        var l = Math.sqrt(this.x * this.x + this.y * this.y);
        // 新しいx成分
        var newX = l * Math.cos(r);
        var newY = l * Math.sin(r);
        // 分解ベクトルを返す
        return new Vector2(newX, newY);
    }

    // ベクトルを指定角度時計回りに回転した座標系に分解する
    public getResolutionDegrees(degrees : number) : Vector2
    {
        var radian = degrees * Math.PI / 180;
        return this.getResolution(radian);
    }

    // JSON
    public toJSON()
    {
        // JSONパース用オブジェクト
        var cloneObj = {
            x : this.x,
            y : this.y,
        };

        return cloneObj;
    }

    public static createFromJsonData(jsonData : any)
    {
        var vector2 = new Vector2();
        if(jsonData.x) { vector2.x = jsonData.x; }
        if(jsonData.y) { vector2.y = jsonData.y; }

        return vector2;
    }
}